import { Zone } from "zone.js/lib/zone-impl";
import { GridSettingsType, Layer } from "../models/layer.model";
import {
    BaseProperties,
  BlurProperties,
  BuildingProperties,
  ColorOverlayProperties,
  ContourProperties,
  DropShadowProperties,
  GridLinesProperties,
  HeightGlowProperties,
  MaterialOverlayProperties,
  ModifiableProperties,
  NoiseProperties,
  Option,
  OutlineProperties,
  OverlayProperties,
  POIGlowProperties,
  RoadProperties,
  SepiaProperties,
  SharedProperties,
  TextureProperties,
  WaterProperties,
  ZoneProperties
} from "../models/properties.model";

export function getFieldFromLayer(layer: Layer, field: ModifiableProperties | "container"): any | null {
  switch (field) {
    case SharedProperties.BlendingMode:
      return layer.sharedSettings.blendingMode;
    case SharedProperties.Opacity:
      return layer.sharedSettings.opacity;
    case SharedProperties.Name:
      return layer.name;
    case BaseProperties.NilPixelColor:
      return layer.baseLayerSettings?.emptyPixelColor;
    case BaseProperties.NilPixelOpacity:
      return layer.baseLayerSettings?.emptyPixelOpacity;
    case BuildingProperties.BuildingGroup:
      return layer.buildingSettings?.buildingGroup;
    case BuildingProperties.BuildingColor:
      return layer.buildingSettings?.buildingColor;
    case BuildingProperties.BuildingColorOpacity:
      return layer.buildingSettings?.buildingColorOpacity;
    case BuildingProperties.BuildingWeatheredRoofs:
      return layer.buildingSettings?.buildingWeatheredRoof;
    case BuildingProperties.BuildingWeatheredVariation:
      return layer.buildingSettings?.buildingWeatheredRoofVariation;
    case ColorOverlayProperties.ColorOverlayColor:
      return layer.colorOverlaySettings?.color
    case RoadProperties.RoadGroup:
      return layer.roadSettings?.roadGroup;
    case RoadProperties.RoadColor:
      return layer.roadSettings?.roadColor;
    case RoadProperties.RoadColorOpacity:
      return layer.roadSettings?.roadColorOpacity;
    case WaterProperties.WaterColor:
      return layer.waterSettings?.waterColor
    case WaterProperties.WaterMinOpacity:
      return layer.waterSettings?.waterMinOpacity
    case WaterProperties.WaterOpaqueDepth:
      return layer.waterSettings?.waterOpaqueDepth
    case ContourProperties.ContourTotalLines:
      return layer.contourSettings?.contourTotalLines
    case ContourProperties.ContourVisibleRange:
      return [...layer.contourSettings?.contourVisibleRange as number[]]
    case ContourProperties.ContourLineColor:
      return layer.contourSettings?.contourLineColor
    case ContourProperties.ContourLineWidth:
      return layer.contourSettings?.contourLineWidth
    case ContourProperties.ContourResolution:
      return layer.contourSettings?.contourResolution
    case OutlineProperties.OutlineWidth:
      return layer.effectSettings?.outlineSetttings?.outlineWidth
    case OutlineProperties.OutlineInnerOuter:
      return layer.effectSettings?.outlineSetttings?.outlineInnerOutline
    case OutlineProperties.OutlineColor:
      return layer.effectSettings?.outlineSetttings?.outlineColor
    case OutlineProperties.OutlineOpacity:
      return layer.effectSettings?.outlineSetttings?.outlineOpacity
    case BlurProperties.BlurStrength:
      return layer.effectSettings?.blurSettings.blurStrength
    case SepiaProperties.SepiaStrength:
      return layer.effectSettings?.sepiaSettings.sepiaStrength
    case POIGlowProperties.POIGlowColor:
      return layer.poiGlowSettings?.poiGlowColor
    case POIGlowProperties.POIGlowStrength:
      return layer.poiGlowSettings?.poiGlowStrength
    case POIGlowProperties.POIGlowWidth:
      return layer.poiGlowSettings?.poiGlowWidth
    case MaterialOverlayProperties.MaterialOverlaySelector:
      return layer.materialOverlaySettings?.materialOverlaySelector
    case MaterialOverlayProperties.MaterialOverlayColor:
      return layer.materialOverlaySettings?.materialOverlayColor
    case MaterialOverlayProperties.MaterialOverlayOpacity:
      return layer.materialOverlaySettings?.materialOverlayOpacity
    case TextureProperties.TextureSelector:
      return layer.effectSettings.textureSettings.textureSelector
    case TextureProperties.TextureColor:
      return layer.effectSettings.textureSettings.textureColor
    case TextureProperties.TextureScale:
      return layer.effectSettings.textureSettings.textureScale
    case TextureProperties.TextureOpacity:
      return layer.effectSettings.textureSettings.textureOpacity
    case TextureProperties.TextureHideUnderlyingLayer:
      return layer.effectSettings.textureSettings.textureHideUnderlyingLayer
    case HeightGlowProperties.HeightGlowColor:
      return layer.heightGlowSettings?.heightGlowColor
    case HeightGlowProperties.HeightGlowRange:
      return [...layer.heightGlowSettings?.heightGlowRange as number[]]
    case DropShadowProperties.DropShadowColor:
      return layer.effectSettings.dropShadowSettings?.dropShadowColor
    case DropShadowProperties.DropShadowOffsetX:
      return layer.effectSettings.dropShadowSettings?.dropShadowOffsetX
    case DropShadowProperties.DropShadowOffsetY:
      return layer.effectSettings.dropShadowSettings?.dropShadowOffsetY
    case DropShadowProperties.DropShadowLength:
      return layer.effectSettings.dropShadowSettings?.dropShadowLength
    case GridLinesProperties.GridLinesStyle:
      return layer.gridLinesSettings?.style
    case GridLinesProperties.GridLinesColor:
      return layer.gridLinesSettings?.color
    case GridLinesProperties.GridLinesOpacity:
      return layer.gridLinesSettings?.opacity
    case GridLinesProperties.GridLinesDensity:
      return layer.gridLinesSettings?.density
    case GridLinesProperties.GridLinesOffsetX:
      return layer.gridLinesSettings?.offsetX
    case GridLinesProperties.GridLinesOffsetY:
      return layer.gridLinesSettings?.offsetY
    case NoiseProperties.NoiseType:
      return layer.effectSettings.noiseSettings?.noiseType
    case NoiseProperties.NoiseBlendingMode:
      return layer.effectSettings.noiseSettings?.noiseBlendingMode
    case NoiseProperties.NoiseHideUnderlyingLayer:
      return layer.effectSettings.noiseSettings?.noiseHideUnderlyingLayer
    case NoiseProperties.NoiseFrequency:
      return layer.effectSettings.noiseSettings?.noiseFrequency
    case NoiseProperties.NoiseInvertMask:
      return layer.effectSettings.noiseSettings?.noiseInvertMask
    case NoiseProperties.NoiseColorGradient:
      return layer.effectSettings.noiseSettings?.noiseColorGradient
    case NoiseProperties.NoiseOpacity:
      return layer.effectSettings.noiseSettings?.noiseOpacity
    case NoiseProperties.NoiseSeed:
      return layer.effectSettings.noiseSettings?.noiseSeed
    case NoiseProperties.NoiseFractileOctives:
      return layer.effectSettings.noiseSettings?.noiseFractileOctives
    case NoiseProperties.NoiseFractileGain:
      return layer.effectSettings.noiseSettings?.noiseFractileGain
    case NoiseProperties.NoiseFractileLacunarity:
      return layer.effectSettings.noiseSettings?.noiseFractileLacunarity
    case NoiseProperties.NoiseFractileType:
      return layer.effectSettings.noiseSettings?.noiseFractileType
    case ZoneProperties.ZoneGroup:
      return layer.zoneSettings?.zoneGroup
    case ZoneProperties.ZoneStrokeEnabled:
      return layer.zoneSettings?.zoneStrokeEnabled
    case ZoneProperties.ZoneStokeDashed:
      return layer.zoneSettings?.zoneStrokeDashed
    case ZoneProperties.ZoneStokeDashedLength:
      return layer.zoneSettings?.zoneStrokeDashLength
    case ZoneProperties.ZoneStrokeWidth:
      return layer.zoneSettings?.zoneStrokeWidth
    case ZoneProperties.ZoneDetail:
      return layer.zoneSettings?.zoneDetail
    case ZoneProperties.ZoneFillOpacity:
      return layer.zoneSettings?.zoneFillOpacity
    case ZoneProperties.ZoneFillEnabled:
      return layer.zoneSettings?.zoneFillEnabled
    case ZoneProperties.ZoneFillColor:
      return layer.zoneSettings?.zoneFillColor
    case ZoneProperties.ZoneOffset:
      return layer.zoneSettings?.zoneOffset
    case ZoneProperties.ZoneStrokeColor:
      return layer.zoneSettings?.zoneStrokeColor
    case ZoneProperties.ZoneStrokeOpacity:
      return layer.zoneSettings?.zoneStrokeOpacity
    case OverlayProperties.BlurSpread:
      return layer.sharedSettings.selectionBlur.blurSpread
    case OverlayProperties.BlurSize:
      return layer.sharedSettings.selectionBlur.blurSize
  }
}

export function updateLayerFromFormControl(layer: Layer, fields: { [key in ModifiableProperties]: any }): Layer {
  const clone = JSON.parse(JSON.stringify(layer));
  Object.entries(fields).forEach(([key, value]) => {
    updateLayerProperty(clone, key as ModifiableProperties, value);
  });
  return clone
}

export function updateLayerProperty(layer: Layer, field: ModifiableProperties, value: any): void {
  // Optimize later to use an object [key: ModifiableProperties]: Object.value(modifityProperties)
  if (Object.values(SharedProperties).includes(field as SharedProperties)) {
    return updateSharedLayerProperty(layer, field as SharedProperties, value);
  }
  if (Object.values(OverlayProperties).includes(field as OverlayProperties)) {
    return updateOverlayProperty(layer, field as OverlayProperties, value);
  }
  if (Object.values(BaseProperties).includes(field as BaseProperties)) {
    return updateBaseProperties(layer, field as BaseProperties, value);
  }
  if (Object.values(ColorOverlayProperties).includes(field as ColorOverlayProperties)) {
    return updateColorOverlayProperty(layer, field as ColorOverlayProperties, value);
  }
  if (Object.values(ContourProperties).includes(field as ContourProperties)) {
    return updateContourProperty(layer, field as ContourProperties, value);
  }
  if (Object.values(WaterProperties).includes(field as WaterProperties)) {
    return updateWaterProperty(layer, field as WaterProperties, value);
  }
  if (Object.values(BuildingProperties).includes(field as BuildingProperties)) {
    return updateBuildingLayerProperty(layer, field as BuildingProperties, value);
  }
  if (Object.values(OutlineProperties).includes(field as OutlineProperties)) {
    return updateOutlineProperty(layer, field as OutlineProperties, value);
  }
  if (Object.values(BlurProperties).includes(field as BlurProperties)) {
    return updateBlurProperty(layer, field as BlurProperties, value);
  }
  if (Object.values(SepiaProperties).includes(field as SepiaProperties)) {
    return updateSepiaProperty(layer, field as SepiaProperties, value);
  }
  if (Object.values(POIGlowProperties).includes(field as POIGlowProperties)) {
    return updatePOIGlowProperty(layer, field as POIGlowProperties, value);
  }
  if (Object.values(MaterialOverlayProperties).includes(field as MaterialOverlayProperties)) {
    return updateMaterialOverlayProperty(layer, field as MaterialOverlayProperties, value);
  }
  if (Object.values(TextureProperties).includes(field as TextureProperties)) {
    return updateTextureProperty(layer, field as TextureProperties, value);
  }
  if (Object.values(HeightGlowProperties).includes(field as HeightGlowProperties)) {
    return updateHeightGlowProperty(layer, field as HeightGlowProperties, value);
  }
  if (Object.values(RoadProperties).includes(field as RoadProperties)) {
    return updateRoadLayerProperty(layer, field as RoadProperties, value);
  }
  if (Object.values(DropShadowProperties).includes(field as DropShadowProperties)) {
    return updateDropShadowProperty(layer, field as DropShadowProperties, value);
  }
  if (Object.values(GridLinesProperties).includes(field as GridLinesProperties)) {
    return updateGridLinesProperty(layer, field as GridLinesProperties, value);
  }
  if (Object.values(NoiseProperties).includes(field as NoiseProperties)) {
    return updateNoiseProperty(layer, field as NoiseProperties, value);
  }
  if (Object.values(ZoneProperties).includes(field as ZoneProperties)) {
    return updateZonesProperty(layer, field as ZoneProperties, value);
  }
}

function updateZonesProperty(layer: Layer, field: ZoneProperties, value: any): void {
  if (!layer.zoneSettings) return
  switch (field) {
    case ZoneProperties.ZoneGroup:
      layer.zoneSettings.zoneGroup = value
      break
    case ZoneProperties.ZoneStrokeEnabled:
      layer.zoneSettings.zoneStrokeEnabled = value
      break
    case ZoneProperties.ZoneStokeDashed:
      layer.zoneSettings.zoneStrokeDashed = value
      break
    case ZoneProperties.ZoneStokeDashedLength:
      layer.zoneSettings.zoneStrokeDashLength = value
      break
    case ZoneProperties.ZoneStrokeWidth:
      layer.zoneSettings.zoneStrokeWidth = value
      break
    case ZoneProperties.ZoneDetail:
      layer.zoneSettings.zoneDetail = value
      break
    case ZoneProperties.ZoneFillOpacity:
      layer.zoneSettings.zoneFillOpacity = value
      break
    case ZoneProperties.ZoneFillEnabled:
      layer.zoneSettings.zoneFillEnabled = value
      break
    case ZoneProperties.ZoneFillColor:
      layer.zoneSettings.zoneFillColor = value
      break
    case ZoneProperties.ZoneOffset:
      layer.zoneSettings.zoneOffset = value
      break
    case ZoneProperties.ZoneStrokeColor:
      layer.zoneSettings.zoneStrokeColor = value
      break
    case ZoneProperties.ZoneStrokeOpacity:
      layer.zoneSettings.zoneStrokeOpacity = value
      break
  }
}

function updateNoiseProperty(layer: Layer, field: NoiseProperties, value: any): void {
  if (!layer.effectSettings.noiseSettings) return
  switch (field) {
    case NoiseProperties.NoiseType:
      layer.effectSettings.noiseSettings.noiseType = value
      break
    case NoiseProperties.NoiseBlendingMode:
      layer.effectSettings.noiseSettings.noiseBlendingMode = value
      break
    case NoiseProperties.NoiseHideUnderlyingLayer:
      layer.effectSettings.noiseSettings.noiseHideUnderlyingLayer = value
      break
    case NoiseProperties.NoiseFrequency:
      layer.effectSettings.noiseSettings.noiseFrequency = value
      break
    case NoiseProperties.NoiseInvertMask:
      layer.effectSettings.noiseSettings.noiseInvertMask = value
      break
    case NoiseProperties.NoiseColorGradient:
      layer.effectSettings.noiseSettings.noiseColorGradient = value
      break
    case NoiseProperties.NoiseOpacity:
      layer.effectSettings.noiseSettings.noiseOpacity = value
      break
    case NoiseProperties.NoiseFractileLacunarity:
      layer.effectSettings.noiseSettings.noiseFractileLacunarity = value
      break
    case NoiseProperties.NoiseFractileGain:
      layer.effectSettings.noiseSettings.noiseFractileGain = value
      break
    case NoiseProperties.NoiseFractileOctives:
      layer.effectSettings.noiseSettings.noiseFractileOctives = value
      break
    case NoiseProperties.NoiseFractileType:
      layer.effectSettings.noiseSettings.noiseFractileType = value
      break
    case NoiseProperties.NoiseSeed:
      layer.effectSettings.noiseSettings.noiseSeed = value
  }
}

function updateGridLinesProperty(layer: Layer, field: GridLinesProperties, value: any): void {
  if (!layer.gridLinesSettings) return
  switch (field) {
    case GridLinesProperties.GridLinesStyle:
      layer.gridLinesSettings.style = value
      break
    case GridLinesProperties.GridLinesColor:
      layer.gridLinesSettings.color = value
      break
    case GridLinesProperties.GridLinesOpacity:
      layer.gridLinesSettings.opacity = value
      break
    case GridLinesProperties.GridLinesDensity:
      layer.gridLinesSettings.density = value
      break
    case GridLinesProperties.GridLinesOffsetX:
      layer.gridLinesSettings.offsetX = value
      break
    case GridLinesProperties.GridLinesOffsetY:
      layer.gridLinesSettings.offsetY = value
      break
  }
}

function updateDropShadowProperty(layer: Layer, field: DropShadowProperties, value: any): void {
  if (!layer.effectSettings.dropShadowSettings) return
  switch (field) {
    case DropShadowProperties.DropShadowColor:
      layer.effectSettings.dropShadowSettings.dropShadowColor = value
      break
    case DropShadowProperties.DropShadowOffsetX:
      layer.effectSettings.dropShadowSettings.dropShadowOffsetX = value
      break
    case DropShadowProperties.DropShadowOffsetY:
      layer.effectSettings.dropShadowSettings.dropShadowOffsetY = value
      break
    case DropShadowProperties.DropShadowLength:
      layer.effectSettings.dropShadowSettings.dropShadowLength = value
      break
  }
}

function updateHeightGlowProperty(layer: Layer, field: HeightGlowProperties, value: any): void {
  if (!layer.heightGlowSettings) return
  switch (field) {
    case HeightGlowProperties.HeightGlowColor:
      layer.heightGlowSettings.heightGlowColor = value
      break
    case HeightGlowProperties.HeightGlowRange:
      layer.heightGlowSettings.heightGlowRange = value
      break
  }
}

function updateTextureProperty(layer: Layer, field: TextureProperties, value: any): void {
  if (!layer.effectSettings.textureSettings) return
  switch (field) {
    case TextureProperties.TextureScale:
      layer.effectSettings.textureSettings.textureScale = value
      break
    case TextureProperties.TextureColor:
      layer.effectSettings.textureSettings.textureColor = value
      break
    case TextureProperties.TextureOpacity:
      layer.effectSettings.textureSettings.textureOpacity = value
      break
    case TextureProperties.TextureSelector:
      layer.effectSettings.textureSettings.textureSelector = value
      break
    case TextureProperties.TextureHideUnderlyingLayer:
      layer.effectSettings.textureSettings.textureHideUnderlyingLayer = value
      break
  }
}

function updateMaterialOverlayProperty(layer: Layer, field: MaterialOverlayProperties, value: any): void {
  if (!layer.materialOverlaySettings) return
  switch (field) {
    case MaterialOverlayProperties.MaterialOverlayColor:
      layer.materialOverlaySettings.materialOverlayColor = value
      break
    case MaterialOverlayProperties.MaterialOverlayOpacity:
      layer.materialOverlaySettings.materialOverlayOpacity = value
      break
    case MaterialOverlayProperties.MaterialOverlaySelector:
      layer.materialOverlaySettings.materialOverlaySelector = value
      break
  }
}

function updatePOIGlowProperty(layer: Layer, field: POIGlowProperties, value: any): void {
  if (!layer.poiGlowSettings) return
  switch (field) {
    case POIGlowProperties.POIGlowColor:
      layer.poiGlowSettings.poiGlowColor = value
      break
    case POIGlowProperties.POIGlowStrength:
      layer.poiGlowSettings.poiGlowStrength = value
      break
    case POIGlowProperties.POIGlowWidth:
      layer.poiGlowSettings.poiGlowWidth = value
      break
  }
}

function updateContourProperty(layer: Layer, field: ContourProperties, value: any): void {
  if (!layer.contourSettings) return
  switch (field) {
    case ContourProperties.ContourTotalLines:
      layer.contourSettings.contourTotalLines = value
      break
    case ContourProperties.ContourResolution:
      layer.contourSettings.contourResolution = value
      break
    case ContourProperties.ContourVisibleRange:
      layer.contourSettings.contourVisibleRange = value
      break
    case ContourProperties.ContourLineColor:
      layer.contourSettings.contourLineColor = value
      break
    case ContourProperties.ContourLineWidth:
      layer.contourSettings.contourLineWidth = value
      break
  }
}

function updateBlurProperty(layer: Layer, field: BlurProperties, value: any): void {
  switch (field) {
    case BlurProperties.BlurStrength:
      layer.effectSettings.blurSettings.blurStrength = value
      break
  }
}

function updateSepiaProperty(layer: Layer, field: SepiaProperties, value: any): void {
  switch (field) {
    case SepiaProperties.SepiaStrength:
      layer.effectSettings.sepiaSettings.sepiaStrength = value
      break
  }
}

function updateOutlineProperty(layer: Layer, field: OutlineProperties, value: any): void {
  switch (field) {
    case OutlineProperties.OutlineWidth:
      layer.effectSettings.outlineSetttings.outlineWidth = value
      break
    case OutlineProperties.OutlineOpacity:
      layer.effectSettings.outlineSetttings.outlineOpacity = value
      break
    case OutlineProperties.OutlineColor:
      layer.effectSettings.outlineSetttings.outlineColor = value
      break
    case OutlineProperties.OutlineInnerOuter:
      layer.effectSettings.outlineSetttings.outlineInnerOutline = value
      break
  }
}

function updateWaterProperty(layer: Layer, field: WaterProperties, value: any): void {
  if (!layer.waterSettings) return
  switch (field) {
    case WaterProperties.WaterColor:
      layer.waterSettings.waterColor = value
      break
    case WaterProperties.WaterMinOpacity:
      layer.waterSettings.waterMinOpacity = value
      break
    case WaterProperties.WaterOpaqueDepth:
      layer.waterSettings.waterOpaqueDepth = value
      break
  }
}

function updateBaseProperties(layer: Layer, field: BaseProperties, value: any): void {
  if (!layer.baseLayerSettings) return
  switch (field) {
    case BaseProperties.NilPixelColor:
      layer.baseLayerSettings.emptyPixelColor = value
      break
    case BaseProperties.NilPixelOpacity:
      layer.baseLayerSettings.emptyPixelOpacity = value
      break
  }
}

function updateSharedLayerProperty(layer: Layer, field: SharedProperties, value: any): void {
  switch (field) {
    case SharedProperties.Opacity:
      layer.sharedSettings.opacity = value;
      break;
    case SharedProperties.Name:
      layer.name = value;
      break;
    case SharedProperties.BlendingMode:
      layer.sharedSettings.blendingMode = value
  }
}

function updateColorOverlayProperty(layer: Layer, field: ColorOverlayProperties, value: any): void {
  if (!layer.colorOverlaySettings) return
  switch (field) {
    case ColorOverlayProperties.ColorOverlayColor:
      layer.colorOverlaySettings.color = value
      break
  }
}

function updateBuildingLayerProperty(layer: Layer, field: BuildingProperties, value: any): void {
  if (!layer.buildingSettings) return
  switch (field) {
    case BuildingProperties.BuildingGroup:
      layer.buildingSettings.buildingGroup = value;
      break;
    case BuildingProperties.BuildingColor:
      layer.buildingSettings.buildingColor = value;
      break;
    case BuildingProperties.BuildingColorOpacity:
      layer.buildingSettings.buildingColorOpacity = value;
      break;
    case BuildingProperties.BuildingWeatheredRoofs:
      layer.buildingSettings.buildingWeatheredRoof = value
      break
    case BuildingProperties.BuildingWeatheredVariation:
      layer.buildingSettings.buildingWeatheredRoofVariation = value;
      break
  }
}

function updateOverlayProperty(layer: Layer, field: OverlayProperties, value: any): void {
  switch (field) {
    case OverlayProperties.BlurSize:
      layer.sharedSettings.selectionBlur.blurSize = value
      break;
    case OverlayProperties.BlurSpread:
      layer.sharedSettings.selectionBlur.blurSpread = value
      break;
  }
}


function updateRoadLayerProperty(layer: Layer, field: RoadProperties, value: any): void {
  if (!layer.roadSettings) return
  switch (field) {
    case RoadProperties.RoadGroup:
      layer.roadSettings.roadGroup = value;
      break;
    case RoadProperties.RoadColor:
      layer.roadSettings.roadColor = value;
      break;
    case RoadProperties.RoadColorOpacity:
      layer.roadSettings.roadColorOpacity = value;
      break;
  }
}

export function generateEncodingGroupOptions(): Option[] {
  const options: Option[] = []
  for (let i = 1; i < 256; i++) {
    options.push({
      label: i.toString(),
      value: i
    })
  }
  return options
}
